/**
 * @file: ErpAutoSyncMode.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpAutoSyncMode {
  Inbound = 'inbound',
  Outbound = 'outbound',
  Bidirectional = 'bidirectional',
}

export const ErpAutoSyncModeValueSet = new Set([
  ErpAutoSyncMode.Inbound,
  ErpAutoSyncMode.Outbound,
  ErpAutoSyncMode.Bidirectional,
]);
